export const SectionScrollIds = {
  PetOnboard: "po",
  PriorityBoarding: "pb",
  TravelInsurance: "ti",
  BoardingPass: "bp",
  OversizedBag: "ob",
  Baggage: "bg",
} as const;
